module.exports = __webpack_public_path__ + "static/media/html5.676e8188.svg";